import { z } from 'zod'

import { codePointLength } from '~/libs/codePoint'

/** 承認コメントの上限 (文字数)。 proto の `reason` の `max_len` と同値 (input-character-limits.md の説明・メモ系)。 */
export const APPROVE_COMMENT_MAX_LENGTH = 100

/**
 * 承認ダイアログのフォームスキーマ。
 * コメントは任意で、 上限は 100 文字 (approval-tasks.md §2)。 BFF の protovalidate
 * (`string.max_len`) が文字数 (コードポイント) で数えるので、 UI も UTF-16 の長さでなく
 * コードポイントで数える。
 */
export const approveFormSchema = z.object({
  comment: z
    .string()
    .refine(
      (value) => codePointLength(value) <= APPROVE_COMMENT_MAX_LENGTH,
      `承認コメントは${APPROVE_COMMENT_MAX_LENGTH}文字以内で入力してください`,
    )
    .optional(),
})

export type ApproveFormValues = z.infer<typeof approveFormSchema>
